import React from 'react';

import Carousel from 'react-multi-carousel';
import blueDots from './../../../assets/images/static/blueIllus.jpg';

import { Player } from 'video-react';
import { videolist } from './Videoslist';

import {
  StyledVideoCarousel,
  VideoTutorialSection,
  Title,
  CarouselThumnail,
  VideoSection,
  VideoDetails,
  LoadMoreBtn,
  DotsImg,
} from './../styled';

const VideoCarosel = () => {
  
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 575 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 575, min: 0 },
      items: 1,
    }
  };

  return (
    <StyledVideoCarousel>
      <VideoTutorialSection>
        <Title>How to Sign in?</Title>
        <Carousel
          responsive={responsive}
          infinite={true}
          autoPlay={true}
          itemClass="carousel-item-padding-40-px"
        >
        {
          videolist.map((list) =>(
            <CarouselThumnail key={list.id}>
              <VideoSection>
                <Player
                  playsInline
                  poster={list.poster}
                  src={list.source}
                />
              </VideoSection>
              <VideoDetails>
                {list.title}
              </VideoDetails>
            </CarouselThumnail>
          ))
        }
        </Carousel>
      </VideoTutorialSection>
      <VideoTutorialSection>
        <Title className='secondTitle'>How our Inventory works?</Title>
        <Carousel
          responsive={responsive}
          infinite={true}
          autoPlay={true}
          itemClass="carousel-item-padding-40-px"
        >
        {
          videolist.map((list) =>(
            <CarouselThumnail key={list.id}>
              <VideoSection>
                <Player
                  playsInline
                  poster={list.poster}
                  src={list.source}
                />
              </VideoSection>
              <VideoDetails>
                {list.title}
              </VideoDetails>
            </CarouselThumnail>
          ))
        }
        </Carousel>
      </VideoTutorialSection>
      <LoadMoreBtn>Load More</LoadMoreBtn>
      <DotsImg 
        src={blueDots} 
        className='hideonMobile'
      />
    </StyledVideoCarousel>
  )
}

export default VideoCarosel;